import { render, staticRenderFns } from "./FirstYearDetail.vue?vue&type=template&id=23b71f6c&class=bap&"
import script from "./FirstYearDetail.vue?vue&type=script&lang=js&"
export * from "./FirstYearDetail.vue?vue&type=script&lang=js&"
import style0 from "./FirstYearDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports